import { render, staticRenderFns } from "./yi-submit-bar.vue?vue&type=template&id=6e07bb07&scoped=true&"
import script from "./yi-submit-bar.vue?vue&type=script&lang=js&"
export * from "./yi-submit-bar.vue?vue&type=script&lang=js&"
import style0 from "./yi-submit-bar.vue?vue&type=style&index=0&id=6e07bb07&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e07bb07",
  null
  
)

component.options.__file = "src/components/yi-submit-bar/yi-submit-bar.vue"
export default component.exports